import { useQuery } from 'react-query';
import { checkEnterpriseAvailableCalendarSlotsRoute } from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useCheckEnterpriseAvailableCalendarSlotsProps = {
  enabled: boolean;
  companyId?: number;
  jobId?: number | string;
  application_ids?: number[];
};

export const useCheckEnterpriseAvailableCalendarSlots = ({
  enabled = false,
  companyId,
  jobId,
  application_ids,
}: useCheckEnterpriseAvailableCalendarSlotsProps) => {
  const applicationsCountsKey = 'enterpriseCalendarSlots';

  const buildQueryString = () => {
    const params = new URLSearchParams();

    if (companyId !== undefined) {
      params.append('company_id', companyId.toString());
    }

    if (jobId !== undefined) {
      params.append('job_id', jobId.toString());
    }

    if (application_ids && application_ids.length > 0) {
      params.append('application_ids', application_ids.join(','));
    }

    return params.toString();
  };

  const queryKey = [applicationsCountsKey, companyId, jobId, application_ids];

  const { data: enterpriseCalendarSlotsData } = useQuery({
    enabled,
    queryKey,
    queryFn: () => {
      const queryString = buildQueryString();
      return axiosInstance
        .get(`${checkEnterpriseAvailableCalendarSlotsRoute}?${queryString}`)
        .then((res) => res.data);
    },
    refetchOnWindowFocus: false,
  });

  return {
    enterpriseCalendarSlotsData,
  };
};
